import { library } from '@fortawesome/fontawesome-svg-core'

import { faGift as falGift } from '@fortawesome/pro-light-svg-icons/faGift'

import { faLongArrowRight as falLongArrowRight } from '@fortawesome/pro-light-svg-icons/faLongArrowRight'

import { faBars as farBas } from '@fortawesome/pro-regular-svg-icons/faBars'
import { faTimes as falTimes } from '@fortawesome/pro-light-svg-icons/faTimes'

library.add(farBas)
library.add(falTimes)
